import React from 'react'
import { IncidenciaInfo } from '../components/Incidences/IncidenciaInfo'


export const IncidenciaInfoPage = () => {
    return (
      <IncidenciaInfo />
    )
}